import { render, staticRenderFns } from "./chineseplus_classlive.vue?vue&type=template&id=4a337366&scoped=true"
import script from "./chineseplus_classlive.vue?vue&type=script&lang=js"
export * from "./chineseplus_classlive.vue?vue&type=script&lang=js"
import style0 from "./chineseplus_classlive.vue?vue&type=style&index=0&id=4a337366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a337366",
  null
  
)

export default component.exports